/** @jsxImportSource @emotion/react */
import { FormLabel } from '@mui/material'
import { CheckboxField } from 'components/Checkbox'

import * as classes from './styles'

type Props = {
  title: string
  label: string
  name: string
}

export const CheckboxWithTitle = ({ title, label, name }: Props) => (
  <FormLabel css={classes.wrapper}>
    <span css={classes.title}>{title}</span>
    <CheckboxField name={name} label={label} />
  </FormLabel>
)
